import { DropdownDTO } from "../../../types/common/DropdownDTO";

/**
 * 🔰 Lista de estados para filtros de eventos de contingencia
 * (No es fake: proviene directamente del flujo del sistema)
 */
export const contingencyStatusDropdown: DropdownDTO[] = [
    { id: 1, name: "STARTED" },
    { id: 2, name: "GENERATING_DTE" },
    { id: 3, name: "EVENT_TRANSMITTED" },
    { id: 4, name: "DTE_TRANSMITTING" },
    { id: 5, name: "CHECKING_RECEPTION" },
    { id: 6, name: "FINISHED" },
];
